// @flow
import React from 'react';
import { getIfGivenRowIsANewlyAddedRow } from '@src/common-utils/utils';

import { StyledSpan } from '../../common-utils/styledComponents';
import { SystemAdminNonAdminStatusLabel } from '../common/SystemAdminNonAdminStatusLabel';
import { IS_ADMIN_EDITED_NAME } from '../../constants';
import { IS_IMPORTED_BACKEND_NAME } from '../renewal-automation/constants';

export const MLDUserTagRibbonContainer = ({ rowValues }) => {
  // For Newly added rows, we don't show the label
  if (getIfGivenRowIsANewlyAddedRow(rowValues)) {
    return null;
  }

  const isAdminEdited = rowValues?.[IS_ADMIN_EDITED_NAME];
  const isImported = rowValues?.[IS_IMPORTED_BACKEND_NAME];

  return (
    <StyledSpan
      style={{
        marginLeft: '-2.75rem',
        marginTop: '0.5rem',
        position: 'absolute',
      }}
    >
      <SystemAdminNonAdminStatusLabel isAddedByAdmin={isAdminEdited} isImported={isImported} />
    </StyledSpan>
  );
};
